import { Component, OnInit } from '@angular/core';
import { CONFIGCONSTANTS } from '../../config/app-constants';

@Component({
  selector: 'app-loader',
  template: `<ngx-ui-loader [fgsColor]="config.fgsColor" [pbColor]="config.pbColor"></ngx-ui-loader>`
})
export class LoaderComponent implements OnInit {
  // theme color : #bb3f42;
  config: any = CONFIGCONSTANTS.loaderConfig;
  constructor () {}
  ngOnInit () {}
}

